import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";
import { scrollToId } from "@/lib/lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Ribbon from "@/components/site/Ribbon";
import Approach from "@/components/site/Approach";
import AvailabilityPublic from "@/components/site/AvailabilityPublic";
import SlotDialog from "@/components/site/SlotDialog";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Home() {
  const [content, setContent] = useState(null);
  const [slots, setSlots] = useState([]);
  const [pickedSlot, setPickedSlot] = useState(null);
  const { hash } = useLocation();

  useEffect(() => {
    // Modo pré-visualização do editor de conteúdo: usa o rascunho salvo no navegador
    // da administradora (localStorage), sem consultar nem alterar o conteúdo publicado.
    if (new URLSearchParams(window.location.search).has("preview")) {
      try {
        const raw = localStorage.getItem("content_preview");
        if (raw) setContent(JSON.parse(raw));
      } catch { /* sem rascunho */ }
      api.get("/availability/public").then(({ data }) => setSlots(data)).catch(() => {});
      if (!content) api.get("/content").then(({ data }) => setContent((c) => c || data)).catch(() => {});
      return;
    }
    api.get("/content").then(({ data }) => setContent(data)).catch(() => {});
    api.get("/availability/public").then(({ data }) => setSlots(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 250);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main className="relative" data-testid="home-page">
      <Helmet>
        <title>Tacilaine Almeida · Psicóloga Online</title>
        <meta name="description" content="Tacilaine Almeida — Psicóloga (CRP 08/33677). Psicoterapia online para adultos em todo o Brasil, com acolhimento, ética e sigilo." />
        <link rel="canonical" href={window.location.origin + "/"} />
        <meta property="og:title" content="Tacilaine Almeida · Psicóloga Online" />
        <meta property="og:description" content="Psicoterapia online para adultos em todo o Brasil, com acolhimento, ética e sigilo." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar content={content} />
      <Hero content={content} />
      <About content={content} />
      <Services content={content} />
      <Ribbon />
      <Approach content={content} />
      <AvailabilityPublic content={content} slots={slots} onPick={(date, time) => setPickedSlot({ date, time })} />
      <Contact content={content} />
      <Footer content={content} />
      <WhatsAppFloat content={content} />
      <SlotDialog slot={pickedSlot} onClose={() => setPickedSlot(null)} />
    </main>
  );
}
